export const getRandomColor = () => {
  const colors = [
    '#f5222d',
    '#fa541c',
    '#fa8c16',
    '#faad14',
    '#fadb14',
    '#a0d911',
    '#52c41a',
    '#13c2c2',
    '#1890ff',
    '#2f54eb',
    '#722ed1',
    '#eb2f96',
  ]
  return colors[Math.floor(Math.random() * 12)]
}

export const oldTenants = []
